export const passwordValidation = (password: string) => ({
	Length: password.length >= 8,
	Number: /\d{1,}/.test(password),
	Mayus: /[A-Z]{1,}/.test(password) || /[Ñ]{1,}/.test(password),
});
